import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.input`
  width: 100%;
  min-width: 120px;
  height: 100%;
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  color: #555555;
  border: none;
  outline: none;
  position: relative;

  ::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
`;


export default Atom({ type: 'timeInput', dataType: ['string', 'number'], template })